import React, { useState, useEffect } from 'react';
import { studentService } from '../../services/api';
import toast from 'react-hot-toast';

const Profile = () => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const studentId = localStorage.getItem('studentId');
      if (!studentId) {
        toast.error('Student ID not found');
        return;
      }
      const response = await studentService.getById(studentId);
      setStudent(response.data.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
      toast.error('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">My Profile</h1>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="space-y-4">
          <div className="flex justify-between border-b pb-3">
            <span className="text-gray-600">Name</span>
            <span className="font-medium">{student?.name}</span>
          </div>
          <div className="flex justify-between border-b pb-3">
            <span className="text-gray-600">Email</span>
            <span className="font-medium">{student?.email}</span>
          </div>
          <div className="flex justify-between border-b pb-3">
            <span className="text-gray-600">Class</span>
            <span className="font-medium">{student?.class} - {student?.section}</span>
          </div>
          <div className="flex justify-between border-b pb-3">
            <span className="text-gray-600">Roll Number</span>
            <span className="font-medium">{student?.rollNumber}</span>
          </div>
          <div className="flex justify-between border-b pb-3">
            <span className="text-gray-600">Parent Name</span>
            <span className="font-medium">{student?.parentName}</span>
          </div>
          <div className="flex justify-between border-b pb-3">
            <span className="text-gray-600">Parent Phone</span>
            <span className="font-medium">{student?.parentPhone}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Address</span>
            <span className="font-medium">{student?.address || 'N/A'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
